import {CompositionScene, CompositionSceneSchema, FinancingCompositionScene} from '@dms/api/shared';

/**
 * Narrows an editor scene to the watermark contract. The watermark editor mode never offers the
 * vehicle photo slot, so a failed parse means a financing scene reached a watermark form.
 */
export const toCompositionScene = (scene: FinancingCompositionScene): CompositionScene | null => {
  const parsed = CompositionSceneSchema.safeParse(scene);

  return parsed.success ? parsed.data : null;
};
